module.exports = __webpack_public_path__ + "static/img/jingshi.ac4c07b9.png";